// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import BankLogoMappingJson from "../BankLogoMapping.json";

let bankLogoMappingJson = BankLogoMappingJson;

let mappingDict = Utils$OrcaPaymentPage.getDictFromJson(bankLogoMappingJson);

let banksByName = Utils$OrcaPaymentPage.getDictFromDict(mappingDict, "banksByName");

let defaultIcon = Utils$OrcaPaymentPage.getString(mappingDict, "defaultIcon", "generic-bank");

function lookupIcon(bankName) {
  return Core__Option.flatMap(banksByName[bankName], Core__JSON.Decode.string);
}

function resolveIconName(bankName) {
  let iconName = lookupIcon(bankName);
  if (iconName !== undefined) {
    return iconName;
  }
  let trimmedName = bankName.trim().replace(/\s+/g, " ");
  return Core__Option.getOr(lookupIcon(trimmedName), defaultIcon);
}

export {
  bankLogoMappingJson,
  mappingDict,
  banksByName,
  defaultIcon,
  lookupIcon,
  resolveIconName,
}
/* bankLogoMappingJson Not a pure module */
